module.exports = __webpack_public_path__ + "static/media/bancontact-dark.6e786090.svg";